var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCashToggle = function SvgCashToggle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.546,2.437a1.957,1.957,0,0,0,2.908,0l.94-1.041a1.959,1.959,0,0,1,3.411,1.413l-.072,1.4A1.96,1.96,0,0,0,19.79,6.266l1.4-.071A1.959,1.959,0,0,1,22.6,9.605l-1.042.941a1.959,1.959,0,0,0,0,2.908l1.042.94a1.959,1.959,0,0,1-1.413,3.411l-1.4-.072a1.96,1.96,0,0,0-2.057,2.056l.072,1.4A1.959,1.959,0,0,1,14.394,22.6l-.94-1.041a1.959,1.959,0,0,0-2.908,0L9.606,22.6A1.959,1.959,0,0,1,6.2,21.191l.072-1.4A1.958,1.958,0,0,0,4.21,17.733l-1.4.072A1.959,1.959,0,0,1,1.4,14.394l1.042-.94a1.959,1.959,0,0,0,0-2.908L1.4,9.605A1.959,1.959,0,0,1,2.809,6.2l1.4.071A1.958,1.958,0,0,0,6.267,4.21L6.2,2.809A1.959,1.959,0,0,1,9.606,1.4Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.875,9H11.25a1.341,1.341,0,0,0-.5,2.587l2.655.825a1.342,1.342,0,0,1-.5,2.588H9.75",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9L12 7.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5L12 15",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCashToggle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cash-toggle.aa2b38ebb1e5ffa231e11850b1289f6c.svg";